import { render, staticRenderFns } from "./LegalCaseEditorParties.vue?vue&type=template&id=22dc9f62&"
import script from "./LegalCaseEditorParties.vue?vue&type=script&lang=js&"
export * from "./LegalCaseEditorParties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports